import { Link } from "react-router-dom";
import { LegalPageLayout } from "@/components/shared/LegalPageLayout";
import { useSeo } from "@/components/shared/useSeo";

const UPDATED = "8 Ağustos 2026";

export default function CerezPolitikasi() {
  useSeo({
    title: "Çerez Politikası | Sistem Elektrik ve Mühendislik",
    description: "Sistem Elektrik ve Mühendislik internet sitesinde çerez ve benzeri teknolojilerin kullanımına ilişkin politika.",
    canonical: "https://sistemmuhendislik.com/cerez-politikasi",
  });

  return (
    <LegalPageLayout
      eyebrow="ÇEREZLER"
      title="Çerez Politikası"
      description="Sistemmuhendislik.com üzerinde çerez ve benzeri teknolojilerin mevcut kullanım durumu hakkında bilgilendirme."
      updatedAt={UPDATED}
    >
      <h2>1. Çerez Nedir?</h2>
      <p>
        Çerezler, bir internet sitesini ziyaret ettiğinizde tarayıcınız aracılığıyla cihazınızda saklanabilen küçük veri dosyalarıdır. Çerezler; sitenin çalışması, tercihlerin hatırlanması, güvenlik, ölçümleme veya reklam gibi farklı amaçlarla kullanılabilir.
      </p>

      <h2>2. Bu Sitedeki Mevcut Kullanım</h2>
      <p>
        Bu politikanın son güncelleme tarihi itibarıyla <strong>sistemmuhendislik.com</strong> uygulama kodunda analitik, reklam, pazarlama veya davranışsal profil oluşturma amacıyla çerez yerleştiren bir araç bulunmamaktadır. Google Analytics, Meta Pixel, Hotjar veya Microsoft Clarity kullanılmamaktadır.
      </p>
      <p>
        Site uygulaması tarafından ziyaretçiyi takip etmek amacıyla birinci taraf çerez veya tarayıcı depolama alanı (localStorage/sessionStorage) kullanılmamaktadır.
      </p>

      <h2>3. Zorunlu Teknik İşlemler ve Üçüncü Taraf Kaynaklar</h2>
      <p>
        Site Netlify altyapısında sunulmaktadır. Ayrıca Google Fonts üzerinden yazı tipleri ve Unsplash üzerinden bazı görseller yüklenmektedir. Bu hizmetlerin sunulması sırasında ilgili sağlayıcılar güvenlik, ağ yönetimi veya hizmetin teknik olarak sağlanması amacıyla bağlantı verilerini ve kendi teknik mekanizmalarını kullanabilir. Bu tür işlemler üçüncü taraf sağlayıcının kendi hizmet ve gizlilik koşullarına tabidir.
      </p>
      <p>
        WhatsApp bağlantısı ancak kullanıcı tarafından tıklandığında açılır. Harici hizmete geçildikten sonraki çerez ve benzeri teknoloji kullanımı WhatsApp/Meta'nın kendi uygulamalarına tabidir.
      </p>

      <h2>4. Zorunlu Olmayan Çerezler Eklenirse</h2>
      <p>
        İleride analitik, performans, kişiselleştirme, reklam veya pazarlama amacıyla zorunlu olmayan çerezlerin eklenmesi hâlinde bu politika güncellenecek; gerekli olduğu ölçüde kullanıcıların aktif tercihine dayanan bir çerez yönetim mekanizması kurulacak ve zorunlu olmayan çerezler ilgili tercih alınmadan çalıştırılmayacaktır.
      </p>

      <h2>5. Tarayıcı Üzerinden Çerez Yönetimi</h2>
      <p>
        Çerezleri tarayıcınızın ayarlarından görüntüleyebilir, silebilir veya engelleyebilirsiniz. Tarayıcı ayarlarının değiştirilmesi bazı internet sitelerinin işlevlerini etkileyebilir. Bu sitede mevcut durumda zorunlu olmayan izleme çerezleri kullanılmadığından ayrıca bir reklam/analitik çerez onay penceresi gösterilmemektedir.
      </p>

      <h2>6. Güncellemeler ve İletişim</h2>
      <p>
        Kullanılan teknolojiler değişirse bu Çerez Politikası da güncellenir. Sorularınız için <a href="mailto:isa@sistemmuhendislik.com">isa@sistemmuhendislik.com</a> adresinden iletişime geçebilirsiniz. Kişisel verilerin işlenmesine ilişkin ayrıntılı bilgi için <Link to="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metni</Link>'ni ve <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>'nı inceleyebilirsiniz.
      </p>
    </LegalPageLayout>
  );
}
